import { useContext, useEffect, useState } from "react";

import Logo from "../Assets/logo/logo.jpg";

import logo from "../Assets/images/advancederp.png";

import AppContext from "../Context/AppContext";

import {
  ATTRIBUTEICON,
  DOCUMENTICON,
  DROPDOWNICON,
  DROPUPICON,
  HOMEICON,
  INQUIRYICON,
  LOGOUTICON,
  MODULEICON,
  MOONICON,
  SUNICON,
  TOGGLEARROWICON,
  USERICON,
} from "../Utils/icons";

import {
  FilePlus2,
  PackageCheck,
  Truck,
  ClipboardList,
  ShoppingCart,
  Ticket,
  Receipt,
  CalendarClock,
  RefreshCw,
  Tag,
  Layers,
  TrendingUp,
  Wallet,
  CalendarDays,
  PackageSearch,
} from "lucide-react";

import { LogicConstants } from "../Utils/logicConstants";

import OpenTabsBar from "./OpenTabsBar";

export default function Sidebar({ logoutHandler }) {
  // activeTab = key of the page currently open in the content area (used for highlighting)
  // openTabs = pages the user has opened from the menu (Dashboard is pinned/non-closable)
  // closeTab = removes a page from openTabs (see AppContext changes noted separately)
  const { setActiveTab, session, activeTab, openTabs, closeTab } = useContext(AppContext);

  const body = document.querySelector("body");

  const toggle = body.querySelector(".toggle");
  const modeSwitch = body.querySelector(".toggle-switch");
  const modeText = body.querySelector(".mode-text");

  const [mode, setMode] = useState("Dark Mode");
  const [isShow, setIsShow] = useState({ module: false, inquiry: false });
  const [isShow_module, setIsShow_module] = useState(false);

  // Hover tooltip for submenu items whose label gets truncated by the sidebar's
  // fixed width. Rendered as a single fixed-position element outside the scrollable
  // menu list (see `.menu-bar .menu { overflow-x: hidden }` in global.css) so it can
  // never get clipped, using the hovered row's own bounding box for placement.
  const [tooltip, setTooltip] = useState(null); // { text, top, left } | null

  const showTooltip = (e, text) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setTooltip({ text, top: rect.top + rect.height / 2, left: rect.right + 10 });
  };
  const hideTooltip = () => setTooltip(null);

  // A menu item is "selected" when its key matches the page currently open in the content area
  const isActive = (key) => activeTab === key;

  // Which page keys belong to each collapsible group. Used to (a) decide whether the
  // parent should be highlighted and (b) auto re-expand the group when one of its
  // pages becomes active — e.g. after opening a tab from OpenTabsBar, or if the sidebar
  // re-renders/remounts for any reason. Keeping this as one source of truth means the
  // parent's active/expanded state can never drift out of sync with its children again.
  const SALES_KEYS = ["inboundOrder", "inboundReceipt", "cpm", "salesOrder", "invoices"];
  const INQUIRY_KEYS = [
    "sku",
    "dailyInventoryTrack",
    "rollingInventory",
    "skuInv",
    "skuBatchTrack",
    "skuTrack",
    "CustomerBalanceInquiry",
    "CustomerAgeing",
    "inboundOrder",
    "inboundReceipt",
    "cpm",
    "ats"
  ];

  const isModuleActive = SALES_KEYS.includes(activeTab);
  const isInquiryActive = INQUIRY_KEYS.includes(activeTab);

  // Auto-expand a group whenever navigation lands on one of its pages, without ever
  // forcing it closed. This is what makes "Sales stays open while I'm inside any Sales
  // page" true regardless of how activeTab got changed (menu click, tab click, refresh,
  // or a remount of this component).
  useEffect(() => {
    if (isModuleActive) {
      setIsShow((prev) => (prev.module ? prev : { ...prev, module: true }));
    }
    if (isInquiryActive) {
      setIsShow((prev) => (prev.inquiry ? prev : { ...prev, inquiry: true }));
    }
  }, [activeTab, isModuleActive, isInquiryActive]);

  // Dashboard fallback safety net.
  //
  // Triggers ONLY when activeTab itself is falsy (null/undefined/empty) — e.g. right
  // after login, or after closeTab() clears activeTab because the closed tab was the
  // one currently open. It deliberately does NOT check whether activeTab is present in
  // openTabs: openTabs is not guaranteed to be updated in the same render pass as a
  // fresh selection (selectHandler just calls setActiveTab), so comparing against it
  // here caused a regression where every normal menu click was immediately overridden
  // back to Dashboard because the newly-clicked page hadn't been reflected into
  // openTabs yet. Falsy-check avoids that entirely while still catching the real
  // "nothing is open" case.
  useEffect(() => {
    if (!activeTab) {
      setActiveTab("dashBoard");
    }
  }, [activeTab, setActiveTab]);

  // Builds the className for a top-level nav item that also acts as a collapsible group header.
  // isGroupActive marks the parent as highlighted whenever activeTab is one of its children,
  // independent of whether the group is currently expanded or collapsed.
  // The static "group-menu" class is a pure CSS hook: it lets the stylesheet tell a
  // collapsible parent (Sales, Inquiry) apart from a plain leaf page (Dashboard, NewOrder)
  // so the two can be styled differently — it has no effect on behavior.
  const navClass = (menuKey, isGroupActive, extra = "") =>
    `nav-links group-menu${isShow[menuKey] ? " expanded" : ""}${isGroupActive ? " active" : ""}${
      extra ? ` ${extra}` : ""
    }`;

  // Builds the className for a leaf (clickable, non-collapsible) sub-menu link.
  const subLinkClass = (key, extra = "") =>
    `sub-menu-link${extra ? ` ${extra}` : ""}${isActive(key) ? " active" : ""}`;

  const toggleHandler = () => {
    const sidebar = document.querySelector(".sidebar");
    // sidebar.classList.toggle("close");
  };

  const modeSwitchHandler = () => {
    body.classList.toggle("dark");
    if (body.classList.contains("dark")) {
      setMode("Dark Mode");
    } else {
      setMode("Light Mode");
    }
  };

  const collapseHandler = (menuKey) => {
    setIsShow((prev) => ({
      ...prev,
      [menuKey]: !prev[menuKey],
    }));
  };

  const iconHandler = () => {
    const sidebar = document.querySelector(".sidebar");
    sidebar.classList.remove("close");
  };

  // Selecting a page both sets it active AND opens its icon-only sidebar back up on mobile,
  // so a single handler drives every leaf nav item consistently.
  const selectHandler = (key) => {
    setActiveTab(key);
    iconHandler();
  };

  return (
    <nav className="sidebar">
      <header>
        <div className="image-text">
          {/* <span className="image"> <img src={Logo} alt="logo" /> </span> */}
          {/* <div className=" text header-text">
            <span className="name">Advanced ERP</span>
          </div> */}
           <div className="login-logo">
            <img src={logo} mode="fit" alt="logo" />
          </div>
        </div>
        <i className="toggle" onClick={() => toggleHandler()}>
          <TOGGLEARROWICON />
        </i>
      </header>

      {/* Open pages: Dashboard is always present, other opened pages can be closed */}
      <OpenTabsBar
        openTabs={openTabs}
        activeTab={activeTab}
        onSelect={setActiveTab}
        onClose={closeTab}
      />

      <div className="menu-bar">
        <div className="menu">
          <ul className="menu-links">
            {/* Dashboard: always the clearly-marked "home" entry point */}
            <li
              className={`nav-links home-link${isActive("dashBoard") ? " active" : ""}`}
              aria-current={isActive("dashBoard") ? "page" : undefined}
            >
              <a onClick={() => selectHandler("dashBoard")}>
                <i className="icon">
                  <HOMEICON />
                </i>
                <span className="text nav-text">DashBoard</span>
              </a>
            </li>

            {/* Sales (module group) */}
            <li
              className={navClass("module", isModuleActive)}
              aria-current={isModuleActive ? "page" : undefined}
            >
              <a
                onClick={(e) => {
                  e.stopPropagation();
                  collapseHandler("module");
                }}
              >
                <i className="icon">
                  <MODULEICON />
                </i>
                <span className="text nav-text">
                  <div>
                    <div className="collapse-link">
                      <div>Sales</div>
                      <div
                        className="collapse-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          collapseHandler("module");
                        }}
                      >
                        {isShow.module ? <DROPDOWNICON /> : <DROPUPICON />}
                      </div>
                    </div>
                  </div>
                </span>
              </a>
            </li>

            {isShow.module ? (
              <ul className="sub-menu">
                {session.loginType === LogicConstants.LOGIN_TYPE_ADMIN_USER ||
                session.loginType === LogicConstants.LOGIN_TYPE_DATA_PORTAL_USER ? (
                  <>
                    <li
                      className={subLinkClass("inboundOrder", "hide")}
                      aria-current={isActive("inboundOrder") ? "page" : undefined}
                      onMouseEnter={(e) => showTooltip(e, "Inbound Orders")}
                      onMouseLeave={hideTooltip}
                    >
                      <a onClick={() => selectHandler("inboundOrder")}>
                        <i className="icon">
                          <PackageCheck size={18} />
                        </i>
                        <span className="text nav-text">Inbound Orders</span>
                      </a>
                    </li>

                    <li
                      className={subLinkClass("inboundReceipt", "hide")}
                      aria-current={isActive("inboundReceipt") ? "page" : undefined}
                      onMouseEnter={(e) => showTooltip(e, "Inbound Receipts")}
                      onMouseLeave={hideTooltip}
                    >
                      <a onClick={() => selectHandler("inboundReceipt")}>
                        <i className="icon">
                          <Truck size={18} />
                        </i>
                        <span className="text nav-text">Inbound Receipts</span>
                      </a>
                    </li>

                    <li
                      className={subLinkClass("cpm", "hide")}
                      aria-current={isActive("cpm") ? "page" : undefined}
                      onMouseEnter={(e) => showTooltip(e, "CPM")}
                      onMouseLeave={hideTooltip}
                    >
                      <a onClick={() => selectHandler("cpm")}>
                        <i className="icon">
                          <ClipboardList size={18} />
                        </i>
                        <span className="text nav-text">CPM</span>
                      </a>
                    </li>

                    <li
                      className={subLinkClass("salesOrder")}
                      aria-current={isActive("salesOrder") ? "page" : undefined}
                      onMouseEnter={(e) => showTooltip(e, "SalesOrder")}
                      onMouseLeave={hideTooltip}
                    >
                      <a onClick={() => selectHandler("salesOrder")}>
                        <i className="icon">
                          <ShoppingCart size={18} />
                        </i>
                        <span className="text nav-text">SalesOrder</span>
                      </a>
                    </li>

                    <li
                      className={subLinkClass("cpm", "hide")}
                      aria-current={isActive("cpm") ? "page" : undefined}
                      onMouseEnter={(e) => showTooltip(e, "PickTicket")}
                      onMouseLeave={hideTooltip}
                    >
                      <a onClick={() => selectHandler("cpm")}>
                        <i className="icon">
                          <Ticket size={18} />
                        </i>
                        <span className="text nav-text">PickTicket</span>
                      </a>
                    </li>

                    <li
                      className={subLinkClass("invoices")}
                      aria-current={isActive("invoices") ? "page" : undefined}
                      onMouseEnter={(e) => showTooltip(e, "Invoices")}
                      onMouseLeave={hideTooltip}
                    >
                      <a onClick={() => selectHandler("invoices")}>
                        <i className="icon">
                          <Receipt size={18} />
                        </i>
                        <span className="text nav-text">Invoices</span>
                      </a>
                    </li>
                  </>
                ) : null}
              </ul>
            ) : null}

            {/* Inquiry group */}

         {/* <ul >
                {session.loginType === LogicConstants.LOGIN_TYPE_ADMIN_USER  ? (
                  <>   */}
            <li
              className={navClass("inquiry", isInquiryActive)}
              aria-current={isInquiryActive ? "page" : undefined}
            >
              <a onClick={(e) => collapseHandler("inquiry")}>
                <i className="icon">
                  <INQUIRYICON />
                </i>
                <span className="text nav-text">
                  <div>
                    <div className="collapse-link">
                      <div>Inquiry</div>
                      <div
                        className="collapse-icon"
                        onClick={(e) => collapseHandler("inquiry")}
                      >
                        {isShow.inquiry ? <DROPDOWNICON /> : <DROPUPICON />}
                      </div>
                    </div>
                    <div></div>
                  </div>
                </span>
              </a>
            </li>

            {isShow.inquiry ? (
              <ul className="sub-menu">

<ul>
  {session.loginType === LogicConstants.LOGIN_TYPE_ADMIN_USER  ? (
    <>
                <li
                  className={subLinkClass("sku")}
                  aria-current={isActive("sku") ? "page" : undefined}
                  onMouseEnter={(e) => showTooltip(e, "Item Inventory")}
                  onMouseLeave={hideTooltip}
                >
                  <a onClick={() => selectHandler("sku")}>
                    <i className="icon">
                      <PackageSearch size={18} />
                    </i>
                    <span className="text nav-text">Item Inventory</span>
                  </a>
                </li>
				
				<li
                  className={subLinkClass("ats")}
                  aria-current={isActive("ats") ? "page" : undefined}
                  onMouseEnter={(e) => showTooltip(e, "ATS")}
                  onMouseLeave={hideTooltip}
                >
                  <a onClick={() => selectHandler("ats")}>
                    <i className="icon">
                      <PackageSearch size={18} />
                    </i>
                    <span className="text nav-text">ATS</span>
                  </a>
                </li>		
                </>
  ):null}		
</ul>
                <li
                  className={subLinkClass("dailyInventoryTrack", "hide")}
                  aria-current={isActive("dailyInventoryTrack") ? "page" : undefined}
                  onMouseEnter={(e) => showTooltip(e, "DailyInventoryTrackHistory")}
                  onMouseLeave={hideTooltip}
                >
                  <a onClick={() => selectHandler("dailyInventoryTrack")}>
                    <i className="icon">
                      <CalendarClock size={18} />
                    </i>
                    <span className="text nav-text">DailyInventoryTrackHistory</span>
                  </a>
                </li>

                <li
                  className={subLinkClass("rollingInventory", "hide")}
                  aria-current={isActive("rollingInventory") ? "page" : undefined}
                  onMouseEnter={(e) => showTooltip(e, "RollingInventory")}
                  onMouseLeave={hideTooltip}
                >
                  <a onClick={() => selectHandler("rollingInventory")}>
                    <i className="icon">
                      <RefreshCw size={18} />
                    </i>
                    <span className="text nav-text">RollingInventory</span>
                  </a>
                </li>

                <li
                  className={subLinkClass("skuInv", "hide")}
                  aria-current={isActive("skuInv") ? "page" : undefined}
                  onMouseEnter={(e) => showTooltip(e, "SKU Details")}
                  onMouseLeave={hideTooltip}
                >
                  <a onClick={() => selectHandler("skuInv")}>
                    <i className="icon">
                      <Layers size={18} />
                    </i>
                    <span className="text nav-text">SKU Details</span>
                  </a>
                </li>

                <li
                  className={subLinkClass("skuBatchTrack", "hide")}
                  aria-current={isActive("skuBatchTrack") ? "page" : undefined}
                  onMouseEnter={(e) => showTooltip(e, "SKU Batch Inventory Track")}
                  onMouseLeave={hideTooltip}
                >
                  <a onClick={() => selectHandler("skuBatchTrack")}>
                    <i className="icon">
                      <Tag size={18} />
                    </i>
                    <span className="text nav-text">SKU Batch Inventory Track</span>
                  </a>
                </li>

                <li
                  className={subLinkClass("skuTrack", "hide")}
                  aria-current={isActive("skuTrack") ? "page" : undefined}
                  onMouseEnter={(e) => showTooltip(e, "SKU Inventory Track")}
                  onMouseLeave={hideTooltip}
                >
                  <a onClick={() => selectHandler("skuTrack")}>
                    <i className="icon">
                      <TrendingUp size={18} />
                    </i>
                    <span className="text nav-text hide">SKU Inventory Track</span>
                  </a>
                </li>

                <li
                  className={subLinkClass("CustomerBalanceInquiry")}
                  aria-current={isActive("CustomerBalanceInquiry") ? "page" : undefined}
                  onMouseEnter={(e) => showTooltip(e, "CustomerBalanceInquiry")}
                  onMouseLeave={hideTooltip}
                >
                  <a onClick={() => selectHandler("CustomerBalanceInquiry")}>
                    <i className="icon">
                      <Wallet size={18} />
                    </i>
                    <span className="text nav-text">CustomerBalanceInquiry</span>
                  </a>
                </li>

                <li
                  className={subLinkClass("CustomerAgeing")}
                  aria-current={isActive("CustomerAgeing") ? "page" : undefined}
                  onMouseEnter={(e) => showTooltip(e, "Customer Aging")}
                  onMouseLeave={hideTooltip}
                >
                  <a onClick={() => selectHandler("CustomerAgeing")}>
                    <i className="icon">
                      <CalendarDays size={18} />
                    </i>
                    <span className="text nav-text">Customer Aging</span>
                  </a>
                </li>

                {session.loginType === LogicConstants.LOGIN_TYPE_ADMIN_USER ||
                session.loginType === LogicConstants.LOGIN_TYPE_SPECIAL_DATA_PORTAL_USER ? (
                  <>
                    <li
                      className={subLinkClass("inboundOrder", "hide")}
                      aria-current={isActive("inboundOrder") ? "page" : undefined}
                      onMouseEnter={(e) => showTooltip(e, "Inbound Orders")}
                      onMouseLeave={hideTooltip}
                    >
                      <a onClick={() => selectHandler("inboundOrder")}>
                        <i className="icon">
                          <PackageCheck size={18} />
                        </i>
                        <span className="text nav-text">Inbound Orders</span>
                      </a>
                    </li>

                    <li
                      className={subLinkClass("inboundReceipt", "hide")}
                      aria-current={isActive("inboundReceipt") ? "page" : undefined}
                      onMouseEnter={(e) => showTooltip(e, "Inbound Receipts")}
                      onMouseLeave={hideTooltip}
                    >
                      <a onClick={() => selectHandler("inboundReceipt")}>
                        <i className="icon">
                          <Truck size={18} />
                        </i>
                        <span className="text nav-text">Inbound Receipts</span>
                      </a>
                    </li>

                    <li
                      className={subLinkClass("cpm", "hide")}
                      aria-current={isActive("cpm") ? "page" : undefined}
                      onMouseEnter={(e) => showTooltip(e, "CPM")}
                      onMouseLeave={hideTooltip}
                    >
                      <a onClick={() => selectHandler("cpm")}>
                        <i className="icon">
                          <ClipboardList size={18} />
                        </i>
                        <span className="text nav-text">CPM</span>
                      </a>
                    </li>
                  </>
                ) : null}
              </ul>
            ) : null}
                  {/* </>
                ) : null}
</ul> */}

<ul>
  {session.loginType === LogicConstants.LOGIN_TYPE_ADMIN_USER  ? (
    <>
            <li
              className={`nav-links${isActive("salesPersonOrder") ? " active" : ""}`}
              aria-current={isActive("salesPersonOrder") ? "page" : undefined}
            >
              <a onClick={() => selectHandler("salesPersonOrder")}>
                <i className="icon">
                  <FilePlus2 size={20} />
                </i>
                <span className="text nav-text">NewOrder</span>
              </a>
            </li>
</>
  ):null}
  </ul>

            {/* <li className="nav-links">
              <a>
                <i className="icon">
                  <ATTRIBUTEICON />
                </i>
                <span className="text nav-text">Attributes</span>
              </a>
            </li> */}
          </ul>
        </div>

        <div className="bottom-content">
          <li className="" 
          
          >
            <a>
              <i className="icon">
                <USERICON />
              </i>
              <span className="text nav-text text-caps">{session.description}</span>
            </a>
          </li>
          <li className="" onClick={logoutHandler}>
            <a>
              <i className="icon">
                <LOGOUTICON />
              </i>
              <span className="text nav-text ">Logout</span>
            </a>
          </li>
          <li className="mode">
            <div className="moon-sun">
              <i className="icon moon">
                <MOONICON />
              </i>
              <i className="icon sun">
                <SUNICON />
              </i>
            </div>
            <div className="toggle-switch" onClick={() => modeSwitchHandler()}>
              <span className="switch"></span>
            </div>
          </li>
        </div>
      </div>

      {/* Rendered here (as a sibling of .menu-bar, not inside its scrollable list) and
          positioned via getBoundingClientRect() in showTooltip, so it always renders on
          top of the sidebar without being clipped by `.menu-bar .menu`'s overflow-x: hidden. */}
      {tooltip && (
        <div
          className="sidebar-tooltip"
          style={{ top: tooltip.top, left: tooltip.left }}
          role="tooltip"
        >
          {tooltip.text}
        </div>
      )}
    </nav>
  );
}